<dx-popup
    title="Automated Audits"
    id="auditInteractionsPopup"
    [(visible)]="isPopupVisible"
    width="400"
    height="500"
    [closeOnOutsideClick]="false"
    [animation]="{
        show: {
            type: 'slide',
            easing: 'ease-out',
            duration: 400,
            from: {
                position: {
                    my: 'center',
                    at: 'right top',
                    of: 'window'
                },
                opacity: 0
            },
            to: {
                position: {
                    my: 'center',
                    at: 'center',
                    of: 'window'
                },
                opacity: 1
            }
        },
        hide: {
            type: 'slide',
            easing: 'ease-in',
            duration: 400,
            from: {
                position: {
                    my: 'center',
                    at: 'center',
                    of: 'window'
                },
                opacity: 1
            },
            to: {
                position: {
                    my: 'center',
                    at: 'right top',
                    of: 'window'
                },
                opacity: 0
            }
        }
    }"
    >
    <div>        
        <p class="audit-text-header">Automated auditing has detected the following issues:</p>
    </div>
    <div *ngFor="let interaction of auditInteractions">
        <ul class="audit-text"><li>{{interaction.message}}</li></ul>
    </div>
    <div>
        <p class="audit-text-footer">These issues may result in unexepcted output, incorrect reports and dashboards, or other problems.</p>
    </div>
    <dxi-toolbar-item
        widget="dxButton"
        toolbar="bottom"
        [options]="{
            icon: '../../../../assets/images/bot-icon.svg',
            text: 'Chat with CoreBot',
            stylingMode: 'contained',
            type: 'default',
            onClick: openChatbot
        }">
    </dxi-toolbar-item>
    <dxi-toolbar-item
        widget="dxButton"
        toolbar="bottom"
        [options]="{
            text: 'Close',
            stylingMode: 'outlined',
            type: 'normal',
            onClick: closePopup
        }">
    </dxi-toolbar-item>
</dx-popup>
